// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__te1T5","gfeWrapper":"CalendarEvent_gfeWrapper__1pbOp"};